@for (alert of alerts.alerts(); track alert.id) {
  <ui-alert [data]="alert" [ngClass]="alert.class"></ui-alert>
}
